import React, { useRef } from 'react';
import EmbedButton from '@playerInterface/EmbedButton';
import useEpisodePlayersContext from '@mainHooks/useEpisodePlayersContext';
import usePlayersContext from '@playerHooks/usePlayersContext';

const Embed = () => {
    const { episodeIndex, showPopupEmbed, popupEmbed } = usePlayersContext();
    const { data } = useEpisodePlayersContext();
    const textareaRef = useRef(null);

    const { episodeEmbedId } = data.episodes[episodeIndex];

    const copyToClipboard = () => {
        const textarea = textareaRef.current;
        textarea.select();

        try {
            document.execCommand('copy');
        } catch (error) {
            console.error('An error occurred while copying to the clipboard:', error);
        }
    };

    return (
        episodeEmbedId && (
            <>
                <EmbedButton />
                {showPopupEmbed && (
                    <div className="player-app__item-popup episode-player-embed">
                        <button onClick={popupEmbed} className="player-app__close-popup">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 4L4 12M4 4L12 12" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </button>
                        <textarea
                            onClick={copyToClipboard}
                            ref={textareaRef}
                            readOnly
                            defaultValue={`<iframe title="Libsyn Player" style="border: none" src="//html5-player.libsyn.com/embed/episode/id/${episodeEmbedId}/height/90/theme/custom/thumbnail/yes/direction/backward/render-playlist/no/custom-color/" height="90" width="100%" scrolling="no" allowfullscreen="" webkitallowfullscreen="" mozallowfullscreen="" oallowfullscreen="" msallowfullscreen="" data-gtm-yt-inspected-6="true" data-gtm-yt-inspected-13="true" data-gtm-yt-inspected-106854517_12="true"></iframe>`}
                        ></textarea>
                    </div>
                )}
            </>
        )
    );
};

export default Embed;
